import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getImagenCredentials } from "./action";

export const imagenSliceEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = imagenSliceEntityAdapter.getInitialState();

export const imagenSlice = createSlice({
  name: "imagen",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getImagenCredentials.fulfilled, (state, action) => {
      if (!action.payload.error) {
        const data = [action.payload.data];

        imagenSliceEntityAdapter.setAll(state, data);
      }
    });
  },
});

export default imagenSlice.reducer;
